import { all, defaultTo, isNilOrEmpty, pick, pipe, values } from '@neo/ramda-extra'

const hasNoErrors = (currentStepProps) =>
  pipe(defaultTo({}), pick(currentStepProps), values, all(isNilOrEmpty))

export { hasNoErrors }
